import { useApiConfig } from '../useApiConfig';

import { PROJECT_PRESETS_QUERY_KEY } from '../../utils/consts';
import { useQueryClient } from '@tanstack/react-query';
import { ProjectPresetsApi } from 'osep-generator-service-client-v1';

function useDeleteProjectPresetsMutation() {
  const { getApiConfig, axiosInstance } = useApiConfig();
  const queryClient = useQueryClient();

  const deleteProjectPresets = async (id: string) => {
    const config = await getApiConfig();
    const projectPresets = new ProjectPresetsApi(
      config,
      undefined,
      axiosInstance,
    );

    const response = await projectPresets.deleteProjectPresets(id);
    await queryClient.invalidateQueries({
      predicate: (query) => query.queryKey.includes(PROJECT_PRESETS_QUERY_KEY),
    });

    return response.data;
  };

  return { deleteProjectPresets };
}

export default useDeleteProjectPresetsMutation;
